module.exports = __webpack_public_path__ + "static/img/nav16.97ad983f.svg";